 <app-table-title [introText]="introText" [title]="titleKey | dictionary"></app-table-title>

 <div class="row">
   <div class="col-lg-12">
     <div class="m-portlet m-portlet--unair" style="margin-bottom: 0px;">
       <div class="pr-2 home-middle-header-bgcolor" style="display: flex;">
         <div class="form-row col-lg-12 pt-2 pb-2 align-items-end">
           <div class="col-md-6 col-sm-12">
             <label class="text-right text-color-1 filter-label-width">{{'FUND' | dictionary}}</label>
             <div style="width: calc(100% - 100px);float: left;">
               <select class="form-control" [(ngModel)]="fund" (ngModelChange)="search()">
                 <option *ngFor="let fund of funds" [value]="fund.FundId">{{fund.Title}}</option>
               </select>
             </div>
           </div>

           <div class="col-md-3 col-sm-12">
             <label class="text-right text-color-1 filter-label-width">{{'TIME_FRAME' | dictionary}}</label>
             <div style="width: calc(100% - 100px);float: left;">
               <select class="form-control" [(ngModel)]="daysToGoBack" (ngModelChange)="search()">
                 <option *ngFor="let timeF of timeFilters" [value]="timeF.Days">{{timeF.Text}}</option>
               </select>
             </div>
           </div>

           <div class="col-md-3 col-sm-12" *ngIf="daysToGoBack =='DR'" style="margin-top: 2px;">
             <div class="date-chooser-wrapper" *ngIf="daysToGoBack =='DR'">
               <DateChooser #txtFromDistDate class="form-control home-login-input-text" (AfterDateSelection)="search()"
                            width="100%" class="SearchField" NullDateLabel="(None)">
               </DateChooser>
             </div>
             <div class="date-chooser-wrapper" *ngIf="daysToGoBack =='DR'">
               <DateChooser #txtToDistDate class="form-control home-login-input-text" (AfterDateSelection)="search()"
                            width="100%" class="SearchField" NullDateLabel="(None)">
               </DateChooser>
             </div>
           </div>

         </div>
       </div>
       <div class="pr-2 home-middle-header-bgcolor" style="display: flex;" *ngIf="isBrokerType">
         <div class="form-row col-lg-12  pt-2 pb-2">
           <div class="col-md-6 col-sm-12">
             <label class="text-right text-color-1 filter-label-width">{{'REP_NAME' | dictionary}}</label>
             <div style="padding: 0px;width: calc(100% - 100px);float: left;">
               <input type="text" class="form-control" [(ngModel)]="repName" (ngModelChange)="onFilterChange()"/>
             </div>
           </div>

           <div class="col-md-3 col-sm-12">
             <label class="text-right text-color-1 filter-label-width">{{'ACCOUNT_NUM' | dictionary}}</label>
             <div style="padding: 0px;width: calc(100% - 100px);float: left;">
               <input type="text" class="form-control" [(ngModel)]="repNum" (ngModelChange)="onFilterChange()"/>
             </div>
           </div>

           <div class="col-md-2 col-sm-12 filter-wrapper house-account-checkbox" *ngIf="isBrokerType">
             <input class="checkbox-field" type="checkbox" [(ngModel)]="houseAccount"
                    (ngModelChange)="onFilterChange()"/>
             <label class="margin-0 text-color-1">{{'HOUSE_ACCOUNT' | dictionary}}</label>
           </div>

         </div>
       </div>
     </div>
   </div>
 </div>

 <div class="row table-container"
      [class.with-padding-for-buttons]="rowSelectionList && rowSelectionList.length > 0">
   <div class="col-lg-12 table-container">
     <kendo-grid [data]="statements"
                 [loading]="loading"
                 [sortable]="{allowUnsort: false, mode: 'single'}"
                 [sort]="sort"
                 [(selectedKeys)]="rowSelectionList"
                 [selectable]="{ enabled: true, mode: 'multiple' }"
                 [kendoGridSelectBy]="'seqNum'"
                 (sortChange)="sortChange($event)"
                 (scrollBottom)="loadMore()">
       <kendo-grid-checkbox-column showSelectAll="true" [style]="{'text-align':'center'}"
                                   [headerClass]="'k-checkbox-all gridheader text-color-1'" [width]="25" field="Label1">
       </kendo-grid-checkbox-column>

       <kendo-grid-column [headerClass]="'gridheader '" field="Label" [width]="200"
                          title="{{'REPORTS_NAME' | dictionary}}"></kendo-grid-column>

       <kendo-grid-column [headerClass]="'gridheader bg-color-1 text-color-1'"
                          field="RepName"
                          width="100"
                          *ngIf="isBrokerType"
                          title="{{'REP_NAME' | dictionary}}">
         <ng-template kendoGridCellTemplate let-dataItem>
           <div>{{ dataItem.RepName }}</div>
         </ng-template>
       </kendo-grid-column>

       <kendo-grid-column [headerClass]="'gridheader text-color-1'" field="FundTitle" [width]="80"
                          title="{{'FUND' | dictionary}}"></kendo-grid-column>
       <kendo-grid-column [headerClass]="'gridheader  text-color-1'"
                          field="StatementDate"
                          title="{{'DATE' | dictionary}}"
                          [width]="50">
         <ng-template kendoGridCellTemplate let-dataItem>
           <div>{{ dataItem.StatementDate | date: "MM/dd/yyyy" }}</div>
         </ng-template>
       </kendo-grid-column>
       <kendo-grid-column [headerClass]="'gridheader text-color-1'" field="seqNum" title="{{'DOWNLOAD' | dictionary}}"
                          [width]="50" align="center" [sortable]="false">
         <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
           <span>{{'DOWNLOAD' | dictionary}}</span>
         </ng-template>
         <ng-template kendoGridCellTemplate let-dataItem>

           <div class="download-icon" *ngIf="dataItem.seqNum != 0"
                (click)="downloadDocument($event, dataItem.seqNum,dataItem.FileNum,dataItem.AppendSeqNum)">
             <i class="fas fa-file-download icon"></i>
           </div>

         </ng-template>
       </kendo-grid-column>
     </kendo-grid>
   </div>
 </div>

 <div class="download-wrapper"
      *ngIf="rowSelectionList && rowSelectionList.length > 0">
   <button type="button" class="button-1" (click)="downloadSelected()">
     <i class="fa fa-download"></i>
     <span *ngIf="rowSelectionList.length === 1"> {{'DOWNLOAD_FILE' | dictionary}}</span>
     <span
       *ngIf="rowSelectionList.length > 1"> {{'DOWNLOAD_FILES' | dictionary : (isAllSelected ? totalRecords : rowSelectionList.length)}}</span>
   </button>
 </div>
 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">

 </app-pop-up-dialog>
